import { Button } from "@newsela/angelou";
import {
  actionNames,
  eventTypes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import Link from "@/components/Link";
import {
  descriptionCss,
  headerContainerCss,
  headerContentInfoCss,
  headerContentTop,
  headingCss,
} from "./ChallengesHeader.style";

interface ChallengesHeaderProps {
  heading: string;
  isHomeVersion?: boolean | undefined;
}

const LinkWithTrackEvent = withTrackEvent(Link);

const ChallengesHeader = ({
  heading,
  isHomeVersion = false,
}: ChallengesHeaderProps) => {
  return (
    <div css={headerContainerCss}>
      <div css={headerContentInfoCss}>
        <div css={headerContentTop}>
          <div css={headerContentTop}>
            <h1 css={headingCss}>{heading}</h1>
            {isHomeVersion && (
              <LinkWithTrackEvent
                href="/challenges"
                styleAnchorAsButton={{
                  flavor: Button.flavors.muted,
                }}
                actionName={actionNames.navigate}
                objectType={objectTypes.user}
                streamProperties={{
                  event_type: eventTypes.click,
                  application: "parnassus",
                  description: "Navigate to Challenges page",
                  component_type: "ChallengeHeader",
                }}
                dataProps={{
                  "data-qa-selector": "IRC: Redirect to Challenge page",
                }}
              >
                View all topics
              </LinkWithTrackEvent>
            )}
          </div>
        </div>
        <p css={descriptionCss}>
          Welcome to this month's reading challenge! Read articles that
          interests you most and earn tokens for every quiz, Power Words and
          Guided Highlighting activity you complete. Earn your monthly badge
          when you reach your reading goal!
        </p>
      </div>
    </div>
  );
};

export default ChallengesHeader;
